.container {
  display: flex;
  flex-direction: column;
  gap: 2px;
  width: 100%;
}

.creditUsageContainer {
  align-items: center;
  align-self: stretch;
  background: rgba(79, 98, 248, 0.15);
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 6px 9px;
  width: 100%;

  &.negativeCredits {
    background: rgba(236, 30, 40, 0.1);
  }

  .top {
    align-items: center;
    display: flex;
    gap: 4px;
  }
}
